import { MAX_LAT_LNG, MIN_LAT_LNG } from "../../cons/MapConstants.js";

export default class LatLng {
  static PRECISION = 0.0001;
  constructor(floatPair) {
    const [lat, lng] = floatPair;
    this.lat = lat;
    this.lng = lng;
  }

  static fromRaw(floatPair) {
    return new LatLng(
      [floatPair[0], floatPair[1]].map(
        (coord) => parseInt(coord / LatLng.PRECISION) * LatLng.PRECISION,
      ),
    );
  }

  static fromReverseRaw(floatPair) {
    return new LatLng(
      [floatPair[1], floatPair[0]].map(
        (coord) => parseInt(coord / LatLng.PRECISION) * LatLng.PRECISION,
      ),
    );
  }

  static fromId(id) {
    const [latStr, lngStr] = id.split("N").map((part) => part.replace("E", ""));
    return new LatLng([parseFloat(latStr), parseFloat(lngStr)]);
  }

  raw() {
    return [this.lat, this.lng];
  }

  get title() {
    return `${this.lat.toFixed(4)}°N, ${this.lng.toFixed(4)}°E`;
  }

  get id() {
    return `${this.lat.toFixed(4)}N${this.lng.toFixed(4)}E`;
  }

  distanceTo(otherLatLng) {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const R = 6371000;
    const dLat = toRad(otherLatLng.lat - this.lat);
    const dLng = toRad(otherLatLng.lng - this.lng);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(this.lat)) *
        Math.cos(toRad(otherLatLng.lat)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  constrainToSriLanka() {
    const [latMin, lngMin] = MIN_LAT_LNG;
    const [latMax, lngMax] = MAX_LAT_LNG;
    const newLat = Math.min(Math.max(this.lat, latMin), latMax);
    const newLng = Math.min(Math.max(this.lng, lngMin), lngMax);
    return new LatLng([newLat, newLng]);
  }
}
